import { rebuildFormula } from "@/config/func";
import { Card, Checkbox, Col, Drawer, Row, Space } from "antd";
import React, { useState, useEffect } from "react";
import { buildOptionsData } from "../buildOption";

const Component = (props: any) => {
  const { status, setStatus, materials, setMaterials,source } = props;
  const [allData,setAllData]=useState<any>(null); //物质列表
  const onClose = () => {
    setStatus(false);
  };

  useEffect(() => {
    if(source){
      setAllData(buidSource(buildOptionsData(source)));
    }
  }, [source]);

  const buidSource=(data:any)=>{
    let s:any={}
    data.forEach((item:any)=>{
      if(s[item.type]){
        s[item.type].push(item);
      }else{
        s[item.type]=[item];
      }
    });
    return s;
  }

  const changeCheck=(e:any,item:any)=>{
    const checked=e.target.checked;
    checked?addMaterial(item):delMaterial(item.id)
  }

  const addMaterial=(item:any)=>{
    setMaterials([
      ...materials,
      {...item}
    ])
  }
  const delMaterial=(id:string)=>{
    const n:any=[];
    materials.map((item:any)=>{
      if(item.id!==id){
        n.push(item)
      }
    })
    setMaterials(n)
  }

  const showContent = (data:any)=>{
    return <Row>
      {data.map((item:any,index:any)=>{
      return (
        <Col span={8} key={index}>
          <Space><Checkbox
          onChange={(e:any)=>changeCheck(e,item)}
          checked={materials.some((m:any)=>m.id===item.id)}
          >{item.name}({rebuildFormula(item.formula)})</Checkbox></Space>
        </Col>
      )
    })}
    </Row>
  }

  return (
    <Drawer
      title="批量设置进料："
      placement="right"
      closable={false}
      onClose={onClose}
      open={status}
      getContainer={false}
      width={700}
    >
      {allData?
      Object.keys(allData).map((key:any)=>{
        return <Card 
        key={key}
        title={<div className="t3">{key}</div>}
        size="small"
        type="inner"
        className="mb1"
        >
          {showContent(allData[key])}
        </Card>
      })
      :''}
    </Drawer>
  );
};

export default Component;
